import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_PVTD_READ_STATISTICS } from 'client/redux/pvtd/constants';

export const instancePvtdReadStatistics = (id, statistic, query) => dispatch => {
  switch (statistic) {
    default: return dispatch(instanceReadStatistics(INSTANCE_PVTD_READ_STATISTICS, id, statistic, query));
  }
};
